<template>
    <div>
        <b-button v-if="row && row.cliente" v-b-popover.hover.top="`Anexos do Cliente ${row.cliente.name}`"
            variant="outline-secondary" @click.prevent="$bvModal.show(`anexos_btn_modal-${row.id}`);" size="sm"><i
                class="fas fa-paperclip"></i></b-button>
        <modal :id="`anexos_btn_modal-${row.id}`" :title="`Anexos do cliente ${row.cliente.name} `">
            <anexos showForm v-if="row.cliente && row.cliente.cliente_documento" :cliente_documento="row.cliente.cliente_documento" :parent_name="parent_name"
                :parent_id="row.id" />
        </modal>
    </div>
</template>
<script>
import Anexos from "./Anexos.vue";
export default {
    components: { Anexos },
    props: {
        parent_name: { type: String, required: true },
        row: { type: Object, required: true },
    }
}
</script>